import { styles } from 'consts';
import styled, { css } from 'styled-components';

const { white } = styles;

export const CheckboxLabel = styled.label`
  display: flex;
  width: 100%;

  input[type='checkbox'] {
    height: 1rem;
    width: 1rem;
    vertical-align: middle;
    margin: 0.1rem 0.4em 0.4em 0;
    border: 2px solid #8fc21c;
    -webkit-appearance: none;
    -webkit-transition: box-shadow 200ms;
  }

  input[type='checkbox'] {
    -webkit-border-radius: 2px;
    border-radius: 2px;
  }

  input[type='checkbox']:not(:disabled):hover {
    border-color: #8fc21c;
  }

  input[type='checkbox']:active:not(:disabled) {
    border-color: #8fc21c;
  }

  input[type='checkbox']:focus {
    outline: none;
  }

  input[type='checkbox']:checked {
    border-color: #8fc21c;
    background-color: #8fc21c;
  }

  input[type='checkbox']:checked:before {
    content: '';
    display: block;
    width: 0.25rem;
    height: 0.4375rem;
    border: solid ${white};
    border-width: 0 2px 2px 0;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
    margin-left: 0.145rem;
  }

  input:disabled {
    opacity: 0.6;
    box-shadow: none;
    background: rgba(0, 0, 0, 0.1);
    box-shadow: none;
  }

  input:disabled + label {
    opacity: 0.6;
    cursor: default;
    -webkit-user-select: none;
  }
`;

export const Wrapper = styled.div<{ isMobile: boolean }>`
  ${props =>
    props.isMobile &&
    css`
      background: #626262;
      border-radius: 8px;
      padding: 0.3rem;
    `}
`;

export const CheckboxTitle = styled.div`
  font-size: 0.875rem;
  margin-bottom: 0.55rem;
  font-weight: 700;
`;

export const CheckboxDescription = styled.div`
  font-size: 0.75rem;
  margin-bottom: 0.55rem;
  text-align: justify;
`;

export const CheckboxInput = styled.input`
  margin-right: 0.625rem;
  display: inline-block;
`;

export const CheckboxButton = styled.span`
  display: inline-block;
  font-size: 0.75rem;
  padding-top: 0.2rem;
`;
